import type { GitFileTreeWithContents, GitTreeItemWithContent } from '../models/git-worker.model';

export async function traverseTreeAsync<T = unknown>(
  tree: GitFileTreeWithContents<T>,
  callback: (item: GitTreeItemWithContent<T>, level: number, parent: GitFileTreeWithContents<T>) => Promise<void>,
  level = 0,
): Promise<void> {
  await Promise.all(
    Object.values(tree).map(async (item) => {
      await callback(item, level || 0, tree);

      if (item.children) {
        await traverseTreeAsync(item.children, callback, level + 1);
      }
    }),
  );
}

export function traverseTree<T = unknown>(
  tree: GitFileTreeWithContents<T>,
  callback: (item: GitTreeItemWithContent<T>, level: number, parent: GitFileTreeWithContents<T>) => void,
  level = 0,
): void {
  Object.values(tree).forEach((item) => {
    callback(item, level || 0, tree);

    if (item.children) {
      traverseTree<T>(item.children, callback, level + 1);
    }
  });
}
